import { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import TelefonoInput from '../../components/ui/TelefonoInput';
import { Button } from 'primereact/button';

const ContactoEditarDialog = ({ visible, onHide, contacto }) => {
    const [nombre, setNombre] = useState('');
    const [correo, setCorreo] = useState('');
    const [telefono, setTelefono] = useState('');

    const handleGuardar = () => {
        onHide();
    };

    return (
        <Dialog 
            header="Editar Contacto" 
            visible={visible} 
            className="p-fluid custom-dialog"
            onHide={onHide}
            footer={
                <div className="flex justify-content-end">
                    <Button label="Grabar" icon="pi pi-save" onClick={handleGuardar} />
                </div>
            }
        >
            <div className="p-fluid">
                <div className="field mb-3">
                    <label htmlFor="nombre" className="block mb-2">Nombre</label>
                    <InputText 
                        id="nombre" 
                        value={nombre} 
                        onChange={(e) => setNombre(e.target.value)} 
                        placeholder="Ingrese su nombre"
                    />
                </div>
                <div className="field mb-3">
                    <label htmlFor="correo" className="block mb-2">Correo</label>
                    <InputText 
                        id="correo" 
                        value={correo} 
                        onChange={(e) => setCorreo(e.target.value)} 
                        placeholder="ejemplo@correo.cl"
                    />
                </div>
                <div className="field mb-3">
                    <label htmlFor="telefono" className="block mb-2">Teléfono</label>
                    <TelefonoInput
                        id="telefono"
                        value={telefono}
                        onChange={setTelefono}
                    />
                </div>
            </div>
        </Dialog>
    );
};

export default ContactoEditarDialog;
